// Module-level bridge: TutorialContext (writer) -> AuthContext axios interceptor (reader).
//
// The request interceptor is built once inside a useMemo on mount, so it closes over
// the environment as it was at that moment and can never see React state that changes
// later. A module variable is read at request time instead, which is the same approach
// already used for the auth token via tokenRef.current.
//
// Purpose: mark requests made while the scripted tutorial is running, so the backend
// can keep those actions out of the behavioral profile.

let _active = false;

export const setTutorialFlag = (value) => {
  _active = !!value;
};

export const isTutorialActive = () => _active;
